import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['categoryFilter', 'rarityFilter']

  filterByCategory() {
    this.applyFilters()
  }

  filterByRarity() {
    this.applyFilters()
  }

  applyFilters() {
    const category = this.categoryFilterTarget.value
    const rarity = this.rarityFilterTarget.value

    const params = new URLSearchParams()
    if (category) params.set('category', category)
    if (rarity) params.set('rarity', rarity)

    const url = params.toString() ?
      `${window.location.pathname}?${params.toString()}` :
      window.location.pathname

    window.location.href = url
  }
}
